import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';

import SahamLogo from 'components/SahamLogo';
import { pushTo } from 'containers/services/routes-helper';
import {
  SideBarSyled,
  StyledDrawer,
  StyledToolbar,
} from 'containers/AppContainer/SideBar/style';
import HamburgerMenu from 'components/HamburgerMenu';
import SideMenu from 'containers/AppContainer/SideBar/SideMenu';

export interface SideBarProps {
  intl: IntlShape;
  isManager?: boolean;
  isExpert?: boolean;
  resetClaim: Function;
  open: boolean;
  setOpen: (b: boolean) => void;
}

const SideBar: React.FC<SideBarProps> = (props): JSX.Element => {
  const { open, setOpen } = props;

  const toggleOpen = () => {
    setOpen(!open);
  };

  const pushToAndReset = (page: string) => () => {
    props.resetClaim();
    pushTo(page)();
  };
  return (
    <SideBarSyled>
      <StyledDrawer
        open={open}
        className="drawer"
        variant="permanent"
        anchor="left"
      >
        <StyledToolbar open={open}>
          {open && (
            <SahamLogo height="53" width="148" isManager={props.isManager} />
          )}
          <HamburgerMenu
            data-testid="hamburger-menu"
            onClick={toggleOpen}
            height="19"
            width="19"
          />
        </StyledToolbar>

        <SideMenu
          pushToAndReset={pushToAndReset}
          isMenuOpen={open}
          isManager={props.isManager}
          isExpert={props.isExpert}
        />
      </StyledDrawer>
    </SideBarSyled>
  );
};

SideBar.defaultProps = {
  isManager: false,
};

export default injectIntl(SideBar);
